module.exports = __webpack_public_path__ + "static/media/ac1.bfa4975d.jpg";